import { render, staticRenderFns } from "./_productProvisions.vue?vue&type=template&id=113a63b2"
import script from "./_productProvisions.vue?vue&type=script&lang=js"
export * from "./_productProvisions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports